import type { RouteRecordRaw } from 'vue-router';

const AuthPage = () => import('@/views/auth/AuthPage.vue');
const CreateAccountPage = () => import('@/views/auth/pages/CreateAccountPage.vue');
const LoginPage = () => import('@/views/auth/pages/LoginPage.vue');
const ResetPasswordPage = () => import('@/views/auth/pages/ResetPasswordPage.vue');
const SignUpPage3 = () => import('@/views/auth/pages/SignUp3.vue');
const ThankYouPage = () => import('@/views/misc/ThankYouPage.vue');
const OnboardingPage = () => import('@/views/onboarding/OnboardingPage.vue');

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/auth',
    name: 'auth',
    alias: '/',
    component: AuthPage,
    children: [
      {
        path: '',
        name: 'login-redirect',
        redirect: { name: 'login' },
        meta: { requireAnonymous: true },
      },
      {
        path: 'login',
        name: 'login',
        component: LoginPage,
        meta: { requireAnonymous: true },
      },
      {
        path: 'signup',
        name: 'signup',
        component: SignUpPage3,
        meta: { requireAnonymous: true },
      },
      {
        path: 'invite/merchant',
        name: 'invite-merchant',
        component: CreateAccountPage,
        meta: { requireAnonymous: true },
      },
      {
        path: 'create-account',
        name: 'create-account',
        component: CreateAccountPage,
        meta: { requireAnonymous: true },
      },
      {
        path: 'thank-you',
        name: 'thank-you',
        component: ThankYouPage,
      },
      {
        path: 'reset-password',
        name: 'reset-password',
        component: ResetPasswordPage,
        meta: { requireAnonymous: true },
      },
    ],
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: OnboardingPage,
  },
  {
    path: '/onboarding/:companyType',
    name: 'onboardings',
    component: OnboardingPage,
  },
];
